import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1dd8709e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd8709e')) {
      api.createRecord('1dd8709e', component.options)
    } else {
      api.reload('1dd8709e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1dd8709e&", function () {
      api.rerender('1dd8709e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/official/home/components/swiper/index.vue"
export default component.exports